import { getToken } from 'firebase/app-check';
import { appCheck } from '../firebase';

export async function fetchWithAppCheck(url, options = {}) {
  const { token } = await getToken(appCheck, false);

  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      'X-Firebase-AppCheck': token,
    },
  });
}